import React from "react";

export interface IBoxItem {
  label: string;
  subLabel?: string | null;
  value?: string | React.ReactNode | null;
  hidden?: boolean;
  isMultiLine?: boolean;
  onClick?: () => void;
}

const BoxItem: React.FC<IBoxItem> = (props): React.ReactElement => {
  return (
    <div
      className={`bg-gray50 flex flex-col rounded-lg px-3 py-2 text-[15px]/7 ${!props.isMultiLine && "sm:flex-row sm:justify-between"} sm:px-5 sm:py-3 sm:text-base/7 ${props.onClick ? "hover:text-primary cursor-pointer" : ""} ${props.hidden ? "hidden" : ""}`}
      onClick={props.onClick}
    >
      <div className="text-[14px]/[28px] tracking-[-0.14px]">
        <div className="text-secondary font-normal">{props.label}</div>
        {props.subLabel && (
          <div className="text-gray-middle -mt-2.5 text-[14px]/[24px] sm:mt-0">
            {props.subLabel}
          </div>
        )}
      </div>
      {!props.value || typeof props.value === "string" ? (
        <div
          className={`-mt-1.5 flex-1 font-bold wrap-anywhere whitespace-normal sm:mt-0 ${!props.isMultiLine && "sm:text-right"}`}
        >
          {!props.value ? "-" : props.value}
        </div>
      ) : (
        props.value
      )}
    </div>
  );
};

export default BoxItem;
